import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const PauseIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon
      cacheName="pause"
      ref={ref}
      {...props}
      sx={{
        width: 64,
        height: 64,
        ...props.sx,
      }}
      viewBox="0 0 64 64"
    >
      <g opacity="0.7">
        <circle cx="32" cy="32" fill="#FF7870" r="22">
          <animate attributeName="r" dur="3s" repeatCount="indefinite" values="23;25;23" />
          <animate attributeName="opacity" dur="3s" repeatCount="indefinite" values="0.2;0.1;0.2" />
        </circle>
      </g>

      <g opacity="0.9">
        <circle cx="32" cy="32" fill="#FF7870" r="20">
          <animate attributeName="r" begin="0.5s" dur="3s" repeatCount="indefinite" values="20;22;20" />
          <animate attributeName="opacity" begin="0.5s" dur="3s" repeatCount="indefinite" values="0.4;0.2;0.4" />
        </circle>
      </g>
      <circle cx="32" cy="32" fill="white" r="18" />
      <circle cx="32" cy="32" fill="#FF7870" r="16" />
      <path
        clipRule="evenodd"
        d="M29 26C28.4477 26 28 26.4477 28 27V37C28 37.5523 28.4477 38 29 38C29.5523 38 30 37.5523 30 37V27C30 26.4477 29.5523 26 29 26ZM35 26C34.4477 26 34 26.4477 34 27V37C34 37.5523 34.4477 38 35 38C35.5523 38 36 37.5523 36 37V27C36 26.4477 35.5523 26 35 26Z"
        fill="white"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
});
